import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import UserManagement from "./pages/UserManagement";
import RecipeManagement from "./pages/RecipeManagement";
import Login from "./pages/login";
import ChangePassword from "./pages/ChangePassword";
import RecipeDetail from "./pages/RecipeDetail";
import AddUser from "./pages/AddUser";
import OpenAIConfig from "./pages/OpenAIConfig";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<UserManagement />} />
                <Route path="/recipe-management" element={<RecipeManagement />} />
                <Route path="/ChangePassword" element={<ChangePassword />} />
                <Route path="/recipe/:id" element={<RecipeDetail />} />
                <Route path="/add-user" element={<AddUser />} />
                <Route path="/openai-config" element={<OpenAIConfig />} />
                
                {/* Add more routes as needed */}
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
